import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-map-marker2-icon',
  templateUrl: './map-marker2.component.html'
})
export class MapMarker2Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
